import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import _moment from 'proxies/dayjs';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { projectionKeys } from './projectiokeys.model';
declare var Razorpay: any
declare global {
  interface Window {
    Paytm: any;
  }
}

@Component({
  selector: 'kx-review-order-modal',
  templateUrl: './review-order-modal.component.html',
  styleUrls: ['./review-order-modal.component.scss'],
  standalone: false
})
export class ReviewOrderModalComponent implements OnInit {
  hasData: any;
  paytm: any;
  showError: boolean = false;
  gatewaydetails: any;
  moment = _moment;
  redirectUrl: any;
  setPayment: boolean = false;
  currentUrl: string;
  previousUrl: string;
  hasReturnUrl: any; keys: projectionKeys;
  resourceDetail: any;
  paramsSubscription: Subscription;
  queryParamsSubscription: Subscription;
  priceData: any;
  resourceData: any;
  mandatoryParamters = ['patient_name', 'telecom', 'emailAddress', 'address.street3', 'address.city', 'address.stateDisplayName', 'address.pincode', 'address.countryDisplayName'];

  constructor(
    private baseService: BaseService,
    private Aroute: ActivatedRoute,
    private loader: LoaderService,
    private router: Router,
    private auth: AuthenticationService,
    private appService: AppService,
    private alertService: AlertsService,
    private utilService: UtilService,
    private storage: StorageService
  ) {
    this.currentUrl = this.router.url;
    this.keys = new projectionKeys();
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      };
    });
  }

  ngOnInit() {
    this.storage.setCurrentResource("payment_gateway")
    // if (window.history.state.navigationId == 2) {
    //   if (this.auth.getUserType() == "patient")
    //     this.router.navigate(['order/my_orders_format/orderList'])
    //   else
    //     this.router.navigate(["/login"]);
    // } else {
    // console.log("called");
    this.setValue()
    // }
  }

  setValue() {
    this.queryParamsSubscription = this.Aroute.queryParams.subscribe((res) => {
      this.hasReturnUrl = res.returnUrl
      if (res.returnUrl.split("").includes("?")) {
        this.hasReturnUrl = res.returnUrl.split("?")[0]
      }
      if (res.payment_type && res.payment_type.toLowerCase() == "credit") {
        this.checkConditionforCredit(this.Aroute.snapshot.params.id, (response) => {
          if (response) {
            if (res.hasOwnProperty('flag') == false) {
              this.loader.showSpinner()
              this.setPayment = true
              this.getResoureName();
            } else {
              this.loader.showSpinner()
              this.getResoureName();
            }
          } else {
            this.alertService.error("Online payment is not allowed for credit payment type.");
          }
        })
      } else {
        if (res.hasOwnProperty('flag') == false) {
          this.loader.showSpinner()
          this.setPayment = true
          this.getResoureName();
        } else {
          this.loader.showSpinner()
          this.getResoureName();
        }
      }
    })
  }

  getResoureName() {
    this.paramsSubscription = this.Aroute.params.subscribe((data: any) => {
      this.baseService.getResourceDef(data.resource, (resouceDef) => {
        if (resouceDef && resouceDef.capability != undefined) {
          //   this.checkIfOnefreeItemPresent(resouceDef);
          // }else{
          this.getResourceDetail(this.getPaymentapibility(resouceDef.capability, "online_payment"));
        }
      })
    })
  }

  checkIfOnefreeItemPresent(resouceDef) {
    this.baseService.get("GET_ORDER_BY_ORDERID", "facility_id:" + this.Aroute.snapshot.params.id + ",orderId:" + this.Aroute.snapshot.queryParams.order_id, "service_request", "order").subscribe(res => {
      if (res.errCode == 0 && res.resource.length > 1) {
        let services = [];
        if (res.resource.filter(res => res.price == 0).length > 0) {
          services.push(res.resource.find(res => res.price == 0));
          services.push(res.resource.find(res => res.serviceRequestId == this.Aroute.snapshot.queryParams.key));
          this.getResourceDetail(this.getPaymentapibility(resouceDef.capability, "online_payment"), services)
        } else {
          this.getResourceDetail(this.getPaymentapibility(resouceDef.capability, "online_payment"))
        }
      } else {
        this.getResourceDetail(this.getPaymentapibility(resouceDef.capability, "online_payment"))
      }
    })
  }

  getPaymentapibility(capibility: any, actionName: any) {
    return capibility.find(x => x.action_name == actionName);
  }

  getResourceDetail(resouceDetail: any, services?) {
    // this.Aroute.params.subscribe((urlData: any) => {
    //   let filter = ""
    if (this.setPayment) {
      //     var args = "id:" + this.Aroute.snapshot.queryParams.key;
      //     if (this.appService.isFacilityAware()) {
      //       args = args + ",facility_id:" + urlData['id']
      //     }
      //     this.baseService.get(resouceDetail.datasource.query_id, args, resouceDetail.datasource.resource, resouceDetail.datasource.application).subscribe((res: any) => {
      // this.hasData = res.resource[0];
      this.getOPAmount(resouceDetail, services)

    } else {
      // let args;
      // if (this.Aroute.snapshot.queryParams.multiple != undefined && this.Aroute.snapshot.queryParams.multiple)
      //   args = "group_transaction_id:" + this.Aroute.snapshot.queryParams.key + ",payment_status:Pending,status:Pending"
      // else
      //   args = "orderId:" + this.Aroute.snapshot.queryParams.key + ",payment_status:Pending,status:Pending";
      // if (this.appService.isFacilityAware()) {
      //   args = args + ",facility_id:" + urlData['id']
      // }
      // this.baseService.get(resouceDetail.detail_datasource.query_id, args, resouceDetail.detail_datasource.resource, resouceDetail.detail_datasource.application, filter).subscribe((res: any) => {
      if (this.Aroute.snapshot.queryParams.multiple != undefined && this.Aroute.snapshot.queryParams.multiple) {
        // this.hasData = res.resource;
        this.getPrice(resouceDetail)
      } else {
        // this.hasData = res.resource[0];
        this.getPrice(resouceDetail)
      }
      // })
    }
    // })
  }

  getOPAmount(resouceDetail: any, service?) {
    var data
    this.storage.getSessionStorageDataSimple("currentData", res => {
      data = JSON.parse(res);
    });
    if (data.admissionId != "") {
      this.resourceData = data;
    }
    let args = {
      "facility_id": this.Aroute.snapshot.params.id,
      "orderedFrom": "Appointment",
      "services": [],
      "patient_id": data.patient_id,
      "payer_details": {
        "payer_id": data.payer_id,
        "payer_name": data.payer_name,
        "payer_payment_type": data.payer_payment_type,
        "payer_type": data.payer_type,
        "payment_typeId": data.payment_typeId
      },
      "uhId": (data.uhId == undefined || data.uhId == "") ? data.preRegistrationNo : data.uhId,
      "serviceRequestId": this.Aroute.snapshot.queryParams.key
    }

    if (this.Aroute.snapshot.queryParams.order_id) {
      args["is_previous_order_required"] = true;
      args.serviceRequestId = "";
      args["edit_price"] = false;
      args["module_name"] = "OP";
      args["order_type"] = data.order_type;
      args["view"] = false;
      args["is_previous_paid"] = false;
      args['orderId'] = this.Aroute.snapshot.queryParams.order_id;
    }

    if (service) {
      args["services"] = service;
      args["is_previous_order_required"] = false;
    }

    if (this.appService.getUniversalConfig('multi_care_type')) {
      args['care_type'] = this.appService.getDynamicFunctions("getCurrentCareType");
    }

    if (this.resourceData.admissionId) {
      this.hitServiceRequestHandler(args, resouceDetail)
    } else {
      this.baseService.action(args, 'GET_AMOUNT', 'facility-management', 'op_amount').subscribe((res: any) => {
        if (res.errCode == 0) {
          if (res.resource.length == 0 || res.resource[0].failed_items.length != 0) {
            this.alertService.error(res.resource[0].failed_items[0].failed_items_message == undefined ? "Doctor Fee is not created" : res.resource[0].failed_items[0].failed_items_message)
          } else {
            let _services = [];
            let result = res.resource[0];
            if (service == undefined && this.Aroute.snapshot.queryParams.order_id) {
              _services.push(result.services.find((services) => services.serviceRequestId == this.Aroute.snapshot.queryParams.key));
              if (result.services.filter((services) => services.price == 0 && services.is_visible != true)) {
                result.services.filter((services) => services.price == 0 && services.is_visible != true).forEach((x) => {
                  _services.push(x);
                })
              }
            }

            let net_payable_payer_amount = _services.reduce(function (prev, cur) {
              return prev + parseFloat(cur.payer_amount);
            }, 0);

            if (_services.length > 1 && _services.length != service?.length && this.Aroute.snapshot.queryParams.order_id) {
              this.getOPAmount(resouceDetail, _services);
              return
            }

            result['net_payable_payer_amount'] = net_payable_payer_amount;
            if (res.resource && res.resource[0] && res.resource[0].discount) {
              result['total_discount'] = res.resource[0].discount;
            }
            result['net_payable_amount'] = res.resource[0].net_amount;
            this.hitServiceRequestHandler(result, resouceDetail)
          }
        } else {
          this.loader.hideSpinner();
          this.alertService.error(res.message);
        }
      })
    }
  }

  getPatient_details(patient: any) {
    return {
      "patient_id": patient.patient_id,
      "patientType": "OP",
      "uhId": patient.uhId,
      "addmissionId": "",
      "profile_id": patient.profile_id,
      "referred_by_name": patient.hasOwnProperty("patient_referral_information") ? (patient.patient_referral_information.refer_name_value == undefined ? "" : patient.patient_referral_information.refer_name_value) : "",
      "referred_by_id": patient.hasOwnProperty("patient_referral_information") ? (patient.patient_referral_information.refer_name == undefined ? "" : patient.patient_referral_information.refer_name) : "",
      "payer_info": {
        "payer_id": patient.payer_details.payer_id,
        "payer_type": patient.payer_details.payer_type,
        "payer_name": patient.payer_details.payer_name
      }
    }
  }

  hitServiceRequestHandler(resource: any, resouceDetail: any) {
    resource["order_device"] = !this.utilService.isMobile() ? "WEB" : (this.utilService.isAndroid() ? "ANDROID" : "IOS");
    resource['is_walkin'] = false;
    resource['patient_details'] = this.getPatient_details(resource)

    if (this.resourceData.admissionId) {
      this.hasGatewayDetails(resouceDetail.datasource)
    }
    else {
      this.baseService.action(resource, "OP_ORDER", "order", "service_request_handler").subscribe((res: any) => {
        if (res.errCode != -1) {
          this.priceData = res.resource[0];
          this.hasGatewayDetails(resouceDetail.datasource)
        } else {
          this.loader.hideSpinner();
          this.alertService.error(res.message);
        }
      })
    }
  }

  // getMultiplePrice(resouceDetail: any) {
  //   let data = {
  //     "filter": "group_transaction_id:" + this.Aroute.snapshot.queryParams.key + ",serviceRequestId:" + this.hasData.map(x => x.serviceRequestId).join("#"),
  //     "args": "facility_id:" + this.Aroute.snapshot.params.id,
  //   }
  //   this.baseService.getData(data, "", "billing_item", "billing", "GET_BULK_PAYMENT_DETAILS").subscribe((response: any) => {
  //     if (response.errCode == -1) {
  //       this.alertService.error(response.message)
  //     } else {
  //       // this.hasData 
  //       this.priceData = response.resource[0]
  //       this.hasGatewayDetails(resouceDetail.datasource)
  //     }
  //   })
  // }

  getPrice(resouceDetail: any) {
    this.baseService.get("GET_BY_ID", "id:" + this.Aroute.snapshot.queryParams.key + ",facility_id:" + this.Aroute.snapshot.params.id, "service_request_handler", "order").subscribe((res: any) => {
      if (res) {
        this.priceData = res.resource[0];
        this.hasGatewayDetails(resouceDetail.datasource)
      } else {
        this.alertService.error(res.message);
      }
    })
  }

  getConfig$(): any {
    return false;
  }

  getPaymentGatewyaList$(): Observable<any> {
    return this.baseService.get("GET_PAYMENT_GATEWAY_LIST", "facility_id:" + this.Aroute.snapshot.params.id, "service_master", "integrator")
  }

  getPaymentDetail$(): Observable<any> {
    let data = {}
    if (this.appService.isFacilityAware()) {
      data = {
        "args": "dummy:dummy,facility_id:" + this.Aroute.snapshot.params.id,
      }
      return this.baseService.getData(data, "", "payment_gateway_details", "payment-gateway", "GET_GATEWAY_DETAILS")
    } else {
      data = {
        "args": "dummy:dummy",
      }
      return this.baseService.getData(data, "", "payment_gateway_details", "payment-gateway", "GET_GATEWAY_DETAILS")
    }
  }

  hasGatewayDetails(resourceDetail: any) {
    this.resourceDetail = resourceDetail;
    if (!this.getConfig$()) {
      this.getPaymentDetail$().subscribe((gatewayDetails: any) => {
        if (gatewayDetails.count == 1) {
          if (gatewayDetails.resource.length == 0) {
            //   this.alertService.error("No Gateway Found !!!");
            //   this.router.navigateByUrl(this.Aroute.snapshot.queryParams.returnUrl);
            this.getRedirectScreenConfig$()
          } else {
            this.gatewaydetails = gatewayDetails.resource;
            this.proceedPayment(gatewayDetails.resource[0])
          }
        }
        else if (gatewayDetails.errCode == -1) {
          //   this.alertService.error(gatewayDetails.message);
          //   this.loader.hideSpinner();
          //   this.router.navigateByUrl(this.Aroute.snapshot.queryParams.returnUrl);
          this.getRedirectScreenConfig$()

        }
        else {
          this.loader.hideSpinner()
          this.gatewaydetails = gatewayDetails.resource;
          // this.proceedPayment(selectedGate, resourceDetail)
        }
      })
    } else {
      this.getPaymentGatewyaList$().subscribe((result: any) => {
        this.loader.hideSpinner()
        if (result.errCode == -1) {
          this.alertService.error(result.message)
          //  this.getRedirectScreenConfig$()
        } else {
          if (result.resource.length == 0) {
            this.alertService.error("No Gateway Found !!!")
            //  this.getRedirectScreenConfig$()
          } else if (result.resource.length == 1) {
            this.gatewaydetails = result.resource;
            this.proceedResponse$(result.resource[0])
          } else {
            this.gatewaydetails = result.resource;
          }
        }
      })
    }
  }

  proceedResponse$(data: any) {
    this.loader.showSpinner();
    let _resource = { "accountId": data.account_id, "facilityId": data.facility_id, "integrationKey": "PAYMENT_REQUEST", "systemName": data.systemName, 'resourceMap': { "orderId": this.priceData[this.resourceDetail.args.orderId], "amount": JSON.stringify(this.priceData[this.resourceDetail.args.amountToPaid] * 100) } }
    this.baseService.action(_resource, "kindle", "integrator", "integrator_request_response").subscribe((result: any) => {
      if (result.errCode == -1) {
        this.alertService.error(result.message);
        this.router.navigateByUrl(this.Aroute.snapshot.queryParams.returnUrl)
      } else {
        result.resource[0] && result.resource[0].responseMap && result.resource[0].responseMap.ig_response && result.resource[0].responseMap.ig_response[0] && result.resource[0].responseMap.ig_response[0].responseCode && result.resource[0].responseMap.ig_response[0].responseCode == "S" && result.resource[0].responseMap.ig_response[0].response[0] ? this.executePaymentGateway$(result.resource[0]) : (this.alertService.error("No Gateway Found !!!"), this.router.navigateByUrl(this.Aroute.snapshot.queryParams.returnUrl))
      }
    })
  }

  executePaymentGateway$(data: any) {
    if (data.responseMap.ig_response[0].gatewayViewType != 'JS') {

    } else {
      var scriptTag = document.createElement('script');
      scriptTag.type = "application/javascript";
      var s = data.responseMap.ig_response[0].gatewayTypeValue;
      scriptTag.src = s;
      document.body.appendChild(scriptTag);
      scriptTag.onload = () => {
        var options = data.responseMap.ig_response[0].response[0];
        var rzp1 = new Razorpay(options);
        rzp1.on('payment.failed', function (response) {
          let _resource = {};
          _resource['extra_data'] = response.error;
          this.baseService.action(_resource, "ADD_RAZORPAY_FAILED_RECORD", "payment-gateway", "epayment_transaction_details").subscribe((res: any) => {
            if (res.errCode != -1) {
              // window.location.href = location.origin + returnUrl + "?status=false&orderId=" + orderId;
            } else {
              this.alertService.error(res.message);
            }
          })
        });
        rzp1.open();
      }
    }
    // var options = `${data.responseMap.ig_response[0].response[0]}`;
    // var rzp1 = new Razorpay(options);
    // rzp1.open();
    // rzp1.on('payment.failed', function (response) {
    //   let _resource = {};
    //   _resource['extra_data'] = response.error;
    //   this.baseService.action(_resource, "ADD_RAZORPAY_FAILED_RECORD", "payment-gateway", "epayment_transaction_details").subscribe((res: any) => {
    //     if (res.errCode != -1) {
    //       // window.location.href = location.origin + returnUrl + "?status=false&orderId=" + orderId;
    //     } else {
    //       this.alertService.error(res.message);
    //     }
    //   })
    // });
  }

  proceedPayment(data: any) {
    this.loader.showSpinner()
    this.hasGatewayResponse$(data, this.resourceDetail.args, this.resourceDetail.redirectUrl).subscribe((res) => {
      if (res?.resource?.[0]?.extra_data == undefined) {
        this.alertService.error("No Payment Gateway Details Found !!!");
        this.router.navigateByUrl(this.Aroute.snapshot.queryParams.returnUrl)
      }
      this.showError = true;
      if (res?.resource?.[0]?.extra_data && Object.keys(res.resource[0].extra_data).length === 0) {
        this.alertService.error("No Payment Gateway Details Found!");
        this.router.navigateByUrl(this.Aroute.snapshot.queryParams.returnUrl);
      } else {
        if (data.gatewayName == "hdfc") { //to be removed need to get data from backend
          this.getEncryptedData(data, res.resource[0]);
        } else if (data.gatewayName == "razorpay") {
          var scriptTag = document.createElement('script');
          scriptTag.type = "application/javascript";
          scriptTag.src = data.razorpay_details.scriptURL;
          document.body.appendChild(scriptTag);
          scriptTag.onload = () => {
            this.createForm(data, res)
          }
          // }
        } else if (data.gatewayName == 'iveri_light' || data.gatewayName == 'razorpay_smart') {
          if (data.gatewayName == 'razorpay_smart') {
            res.resource[0].extra_data = { ...res.resource[0].extra_data, ...data.razorpay_details }
            res.resource[0].extra_data['key_id'] = data.razorpay_details.keyId;
            res.resource[0].extra_data['order_id'] = res.resource[0].extra_data.txnId;
            res.resource[0].extra_data['name'] = data.razorpay_details.merchant_name;
            res.resource[0].extra_data['image'] = this.appService.getAppHeader().logo;
            res.resource[0].extra_data['prefill[name]'] = res.resource[0].extra_data.patient_name;
            res.resource[0].extra_data['prefill[email]'] = res.resource[0].extra_data.patient_email;
            res.resource[0].extra_data['prefill[contact]'] = res.resource[0].extra_data.patient_mobile;
            res.resource[0].extra_data['callback_url'] = location.origin + data.razorpay_details.redirectURL;
            res.resource[0].extra_data['cancel_url'] = location.origin + data.razorpay_details.redirectURL;
          }
          let url = ""; let request = "RequestforDebit"; let type = "post";
          if (data.gatewayName == 'razorpay_smart') {
            url = "https://api.razorpay.com/v1/checkout/embedded"
          }
          if (data.gatewayName == 'iveri_light') {
            url = "https://portal.host.iveri.com/Lite/Authorise.aspx"
          }
          this.createCommonForm(res.resource[0].extra_data, data.gatewayName, url, request, type)
        } else if (data.gatewayName == "hdfc_juspay" && res.resource[0].extra_data.redirect_url) {
          location.href = res.resource[0].extra_data.redirect_url;
        } else if (data.gatewayName == 'billdesk') {
          let url = res.resource[0].extra_data.redirect_url;
          let request = "sdklaunch";
          this.createCommonForm(res.resource[0].extra_data, data.gatewayName, url, request, 'post')
        } else if (data.gatewayName == 'icici') {
          let url = data.icici_details.actionURL;
          this.createCommonForm(res.resource[0].extra_data, data.gatewayName, url, '', 'post')
        } else {
          this.redirectUrl = res.resource[0].redirect_url
          this.paytm = {
            'mid': res['resource'][0].extra_data.MID,
            'orderId': res['resource'][0].extra_data.ORDER_ID,
            'txnToken': res['resource'][0].encryptedData,
            'amount': res['resource'][0].extra_data.TXN_AMOUNT
          }
          var scriptTag = document.createElement('script');
          scriptTag.type = "application/javascript";
          scriptTag.src = `${this.redirectUrl}`
          document.body.appendChild(scriptTag);
          scriptTag.onload = () => {
            this.showPopUp()
          }
        }
      }
    })
    // }
  }

  getAddress(address) {
    return (address && address.street3 ? address.street3 + "," : "") + (address && address.street1 ? address.street1 + "," : "") + (address && address.street2 ? "," + address.street2 : "")
  }

  getEncryptedData(_data: any, res: any) {
    let data: any = "tid=" + JSON.stringify(this.moment().valueOf()) + "&merchant_id=" + _data.hdfc_details.merchantId + "&order_id=" + res.extra_data.txn_id + "&amount=" + res.extra_data.txn_amount + "&currency=" + _data.hdfc_details.currency + "&redirect_url=" + location.origin + _data.hdfc_details.redirectURL + "&cancel_url=" + location.origin + _data.hdfc_details.cancelURL + "&language=" + _data.hdfc_details.language + "&merchant_param1=" + res.extra_data.orderId;
    if (data && !this.mandatoryParamters.map(x => { if (this.storage.getPatientInfo()[x]) { return true } else { return false } }).includes(false) && this.auth.getUserType() == "patient") {
      data += "&billing_name=" + this.storage.getPatientInfo().patient_name + "&billing_address=" + (this.storage.getPatientInfo().address ? this.getAddress(this.storage.getPatientInfo().address) : "") + "&billing_city=" + (this.storage.getPatientInfo().address && this.storage.getPatientInfo().address.city ? this.storage.getPatientInfo().address.city : "") + "&billing_state=" + (this.storage.getPatientInfo().address && this.storage.getPatientInfo().address.stateDisplayName ? this.storage.getPatientInfo().address.stateDisplayName : "") + "&billing_zip=" + (this.storage.getPatientInfo().address && this.storage.getPatientInfo().address.pincode ? this.storage.getPatientInfo().address.pincode : "") + "&billing_country=" + (this.storage.getPatientInfo().address && this.storage.getPatientInfo().address.countryDisplayName ? this.storage.getPatientInfo().address.countryDisplayName : "")
        + "&billing_email=" + (this.storage.getPatientInfo().emailAddress ? this.storage.getPatientInfo().emailAddress : "") + "&billing_tel=" + (this.storage.getPatientInfo().telecom ? this.storage.getPatientInfo().telecom : "") + "&merchant_param2=" + this.baseService.getpatientUhid();
      this.proceedForEncyptedData(_data, data);
    } else {
      if (this.auth.getUserType() == "patient") {
        this.baseService.getPatientUHID().subscribe((response: any) => {
          if (response && response.errCode == 0 && response.resource && response.resource.length > 0) {
            let result = response.resource[0];
            data += "&billing_name=" + result.patient_name + "&billing_address=" + (result.address ? this.getAddress(result.address) : "") + "&billing_city=" + (result.address && result.address.city ? result.address.city : "") + "&billing_state=" + (result.address && result.address.stateDisplayName ? result.address.stateDisplayName : "") + "&billing_zip=" + (result.address && result.address.pincode ? result.address.pincode : "") + "&billing_country=" + (result.address && result.address.countryDisplayName ? result.address.countryDisplayName : "") + `&billing_email=${result.emailAddress ? result.emailAddress : ''}` + "&billing_tel=" + (result.telecom ? result.telecom : "") + "&merchant_param2=" + this.baseService.getpatientUhid();
            this.proceedForEncyptedData(_data, data);
          } else {
            this.alertService.error("Please update patient details to proceed payment");
            this.loader.hideSpinner();
          }
        });
      } else {
        this.proceedForEncyptedData(_data, data);
      }
    }

  }

  proceedForEncyptedData(_data, data) {
    let args = "request:" + btoa(JSON.stringify(data)) + ",facility_id:" + this.Aroute.snapshot.params.id
    this.baseService.get("encrypt", args, "cryptRequestResponse", "payment-gateway").subscribe((result: any) => {
      if (result.errCode == 0) {
        let request = { encRequest: result.resource[0].response, access_code: _data.hdfc_details.accessCode }
        this.createCommonForm(request, "hdfc", _data.hdfc_details.actionURL, "hdc_form");
      } else {
        this.showError = false;
        this.loader.hideSpinner()
        this.alertService.error(result.message);
      }
    })
  }


  ngOnDestroy() {
    var tags = document.getElementsByTagName('script');
    for (let i = tags.length; i >= 0; i--) {
      if (tags[i] && tags[i].getAttribute('src') == `${this.redirectUrl}`)
        tags[i].parentNode.removeChild(tags[i]);
    }
    if (this.queryParamsSubscription)
      this.queryParamsSubscription.unsubscribe();
    if (this.paramsSubscription)
      this.paramsSubscription.unsubscribe();
  }

  hasGatewayResponse$(data: any, resArgs: any, hasUrl): Observable<any> {
    var url = btoa(location.origin + this.hasReturnUrl);
    // var url = btoa("https://karexpert.epc01.kxaction.com"+this.hasReturnUrl)
    var resource = {}; var Arr = [];
    if (this.setPayment) {
      if (this.resourceData && this.resourceData.admissionId) {
      }
      else {
        Arr.push(this.priceData.services[0]["serviceRequestId"])
      }
      if (this.resourceData && this.resourceData.admissionId) {
        resource['amount'] = this.resourceData.patient_due_amount;
      }
      else {
        resource['amount'] = this.priceData[resArgs.amountToPaid];
      }
      if (this.resourceData && this.resourceData.admissionId) {
      }
      else {
        resource['orderId'] = this.priceData.services[0][resArgs.orderId];
      }
      resource['gateway_id'] = data.id;
      if (resArgs.hasOwnProperty("uhId") == true) {
        if (this.resourceData && this.resourceData.admissionId) {
          resource['uhId'] = this.resourceData.uhId;
        }
        else {
          resource['uhId'] = this.priceData[resArgs.uhId];
        }
      }
      else
        resource['transaction_type'] = resArgs.transaction_type;
      if (this.resourceData && this.resourceData.admissionId) {
      }
      else {
        resource['serviceRequestIds'] = Arr;
      }
      resource['source_url'] = url;
      resource['request_source'] = "WEB";
      if (this.resourceData && this.resourceData.admissionId) {
      }
      else {
        resource['service_request_handler_id'] = this.priceData.id;
      }
    } else {
      if (this.Aroute.snapshot.queryParams.multiple == undefined) {
        for (let i = 0; i < this.priceData[resArgs.apptId].length; i++) {
          Arr.push(this.priceData[resArgs.apptId][i]?.serviceRequestId)
        }
      }
      if (this.Aroute.snapshot.queryParams.multiple) {
        for (let i = 0; i < this.priceData.length; i++) {
          Arr.push(this.priceData[i]?.serviceRequestId)
        }
      }
      resource['amount'] = this.priceData[resArgs.amountToPaid];
      if (this.Aroute.snapshot.queryParams.multiple == undefined)
        resource['orderId'] = this.priceData.services[0][resArgs.orderId];
      else
        resource['group_transaction_id'] = this.Aroute.snapshot.queryParams.group_transaction_id
      resource['gateway_id'] = data.id;
      if (resArgs.hasOwnProperty("uhId") == true && this.Aroute.snapshot.queryParams.multiple == undefined)
        resource['uhId'] = this.priceData.patient_details[resArgs.uhId];
      else if (this.Aroute.snapshot.queryParams.multiple)
        resource['transaction_type'] = "billing";
      else
        resource['transaction_type'] = resArgs.transaction_type;
      resource['serviceRequestIds'] = Arr;
      resource['source_url'] = url;
      resource['request_source'] = "WEB";
      resource['service_request_handler_id'] = this.Aroute.snapshot.queryParams.key;
    }
    if (this.resourceData && this.resourceData.admissionId) {
      resource['admissionId'] = this.resourceData.admissionId;
    }
    if (this.resourceData?.bill_no)
      resource['bill_no'] = this.resourceData.bill_no;
    if (this.resourceData?.is_due != null)
      resource['is_due'] = this.resourceData.is_due;

    if (this.appService.isFacilityAware()) {
      resource['facility_id'] = this.Aroute.snapshot.params.id;
      return this.baseService.action(resource, "PROCCED_PAYMENT", "payment-gateway", "ui_gateway_response")
    } else {
      resource['facility_id'] = this.appService.getOrganization().org_id
      return this.baseService.action(resource, "PROCCED_PAYMENT", "payment-gateway", "ui_gateway_response")
    }
  }

  showPopUp() {
    if (this.paytm != undefined) {
      var config = {
        "root": "",
        "flow": "DEFAULT",
        "style": {
          "headerBackgroundColor": "#5CBAF1",
          "headerColor": "#fffff"
        },
        "data": {
          "orderId": this.paytm.orderId,
          "token": this.paytm.txnToken,
          "tokenType": "TXN_TOKEN",
          "amount": this.paytm.amount
        },
        "handler": {
          "notifyMerchant": function (eventName, data) {
            // console.log("notifyMerchant handler function called");
            // console.log("eventName => ", eventName);
            // console.log("data => ", data);
            if (eventName == "APP_CLOSED") {
              window.location.href = window.location.origin + "/order/my_orders_format/orderList"
            }
          }
        }
      };
      if (window.Paytm && window.Paytm.CheckoutJS && window.Paytm.CheckoutJS.onLoad != undefined) {
        window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
          window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
            window.Paytm.CheckoutJS.invoke();
          }).catch(function onError(error) {
            console.log("Error => ", error);
          });
        });
      }
    } else {
      this.router.navigate(['order/my_orders_format/orderList'])
    }
  }

  // createHDFCForm(encData: any, _data: any) {
  //   const my_form: any = document.createElement('form');
  //   my_form.name = 'hdc_form';
  //   my_form.method = 'post';
  //   my_form.action = _data.hdfc_details.actionURL
  //   const hdfc = { encRequest: encData.response, access_code: _data.hdfc_details.accessCode }
  //   const myParams = Object.keys(hdfc);
  //   for (let i = 0; i < myParams.length; i++) {
  //     const key = myParams[i];
  //     let my_tb: any = document.createElement('input');
  //     my_tb.type = 'hidden';
  //     my_tb.name = key;
  //     my_tb.value = hdfc[key];
  //     my_form.appendChild(my_tb);
  //   };

  //   document.body.appendChild(my_form);
  //   my_form.submit();
  // }

  createForm(data, res) {
    var returnUrl = this.hasReturnUrl;
    var _base_service = this.baseService;
    var _alert = this.alertService
    var orderId = res.resource[0].extra_data.orderId;
    var options = {
      "key": data.razorpay_details.keyId,
      "amount": res.resource[0].extra_data.amount,
      "currency": data.razorpay_details.currency,
      "name": data.razorpay_details.merchant_name,
      "description": data.razorpay_details.description,
      "order_id": res.resource[0].extra_data.txnId,
      "image": this.appService.getAppHeader().logo,
      "callback_url": location.origin + data.razorpay_details.redirectURL,
      "redirect": true,
      // "handler": function (response) {
      //   window.location.href = location.origin + returnUrl + "?status=true&orderId=" + response.razorpay_order_id
      // },
      "prefill": {
        "name": res.resource[0].extra_data.patient_name,
        "email": res.resource[0].extra_data.patient_email,
        "contact": res.resource[0].extra_data.patient_mobile
      },   // back button or cancel button 
      "modal": {
        "ondismiss": function () {
          window.location.href = window.location.origin + returnUrl
        }
      },// back button or cancel button
      "notes": {
        "address": data.razorpay_details.merchant_name
      },
      "theme": {
        "color": data.razorpay_details.theme_color
      },
      "retry": {
        "enabled": data.razorpay_details.retryEnabled
      }
    };
    var rzp1 = new Razorpay(options);
    rzp1.on('payment.failed', function (response) {
      let _resource = {};
      _resource['extra_data'] = response.error;
      _base_service.action(_resource, "ADD_RAZORPAY_FAILED_RECORD", "payment-gateway", "epayment_transaction_details").subscribe((res: any) => {
        if (res.errCode != -1) {
          window.location.href = location.origin + returnUrl + "?status=false&orderId=" + orderId;
        } else {
          _alert.error(res.message);
        }
      })
    });
    rzp1.open();

  };

  public getPreviousUrl() {
    return this.previousUrl;
  }

  checkConditionforCredit(facility_id, cb) {
    this.baseService.get("GET_CONFIG", "config_code:appointment_0007,module_code:appointment,facility_id:" + facility_id, "facility_config_mapping", "facility-management").subscribe((res: any) => {
      if (res.errCode == 0) {
        if (res.resource.length == 0) {
          cb(true);
        } else {
          if (res.resource[0] && res.resource[0].config_value && res.resource[0].config_value.toLowerCase() == "yes") {
            this.router.navigateByUrl(this.Aroute.snapshot.queryParams.returnUrl); // redirect back to previous url
            cb(false);
          } else {
            cb(true);
          }
        }
      } else {
        cb(true);
      }
    })
  }

  createCommonForm(data: any, gatewayName, url, form_name = "RequestforDebit", type = "post") {
    const my_form: any = document.createElement('form');
    my_form.name = form_name;
    my_form.method = type;
    my_form.action = url;
    const myParams = Object.keys(data);
    for (let i = 0; i < myParams.length; i++) {
      const key = myParams[i];
      let my_tb: any = document.createElement('input');
      my_tb.type = 'hidden';
      my_tb.name = key;
      if (typeof data[key] == 'string' && data[key] && data[key].includes('localhost') && !data[key].includes('localhost:4599')) {
        data[key] = data[key].replace("localhost", 'localhost:4599')
      }
      my_tb.value = data[key];
      my_form.appendChild(my_tb);
    };

    document.body.appendChild(my_form);
    my_form.submit();
  }


  redirectToMyOrdersConfig$(): Observable<any> {
    return this.baseService.get('GET_CONFIG', "config_code:redirectToMyOrdersAfterBooking,module_code:patient-registration", 'facility_config_mapping', 'facility-management')
  }

  getRedirectScreenConfig$() {
    this.redirectToMyOrdersConfig$().subscribe((res: any) => {
      if (res.errCode == 0 && res.resource && res.resource.length > 0 && res.resource[0].config_value == "yes") {
        this.loader.hideSpinner();
        if (this.auth.getUserType() == "patient") {
          this.loader.hideSpinner();
          this.router.navigate(['order/my_orders_format/orderList'])
        } else {
          this.router.navigateByUrl(this.Aroute.snapshot.queryParams.returnUrl); // redirect back to previous url
        }
      } else {
        this.router.navigateByUrl(this.Aroute.snapshot.queryParams.returnUrl); // redirect back to previous url
      }
    })
  }


}